import {FormState} from "./FormState";
import {
    buscarMascota,
    ModificacionesMascota, modificarMascota,
    Sexo,
    Temperamento
} from '../../../services/mascotasServicios';

export const editarMascota = async (formState: FormState, idMascota: string) => {
    const modificaciones: ModificacionesMascota = {
        idPropietario: undefined,
        nombre: formState.nombre.wasTouched ? formState.nombre.value : undefined,
        idRaza: formState.raza.wasTouched ? formState.raza.value : undefined,
        sexo: formState.sexo.wasTouched ? formState.sexo.value as Sexo : undefined,
        fechaNacimiento: formState.fechaNacimiento.wasTouched ? formState.fechaNacimiento.value : undefined,
        fechaIngreso: formState.fechaIngreso.wasTouched ? formState.fechaIngreso.value : undefined,
        foto: formState.foto.wasTouched ? formState.foto.value : undefined,
        certificadoVacuna: formState.certificadoVacuna.wasTouched ? formState.certificadoVacuna.value : undefined,
        estaEsterilizada: formState.estaEsterilizada.wasTouched ? formState.estaEsterilizada.value : undefined,
        tieneCondicionMedica: formState.tieneCondicionMedica.wasTouched ? formState.tieneCondicionMedica.value : undefined,
        observacionesMedicas: formState.observacionesMedicas.wasTouched ? formState.observacionesMedicas.value : undefined,
        temperamento: formState.temperamento.wasTouched ? formState.temperamento.value as Temperamento : undefined,
        observacionesTemperamento: formState.observacionesTemperamento.wasTouched ? formState.observacionesTemperamento.value : undefined,
        observacionesAlimenticias: formState.observacionesAlimenticias.wasTouched ? formState.observacionesAlimenticias.value : undefined,
        nombreVeterinario: formState.nombreVeterinario.wasTouched ? formState.nombreVeterinario.value : undefined,
        comentarios: formState.comentarios.wasTouched ? formState.comentarios.value : undefined,
        fechaGarrapaticida: formState.fechaGarrapaticida.wasTouched ? formState.fechaGarrapaticida.value : undefined,
        fechaVacuna: formState.fechaVacuna.wasTouched ? formState.fechaVacuna.value : undefined,
        mesesPeriodicidadGarrapaticida: formState.mesesPeriodicidadGarrapaticida.wasTouched && formState.mesesPeriodicidadGarrapaticida.value !== "" ? parseInt(formState.mesesPeriodicidadGarrapaticida.value) : undefined,
        eliminarFoto: formState.eliminarFoto.wasTouched ? formState.eliminarFoto.value : undefined,
        eliminarCertificadoVacuna: formState.eliminarCertificadoVacuna.wasTouched ? formState.eliminarCertificadoVacuna.value : undefined
    }
    await modificarMascota(idMascota, modificaciones);
}

export const cargarMascota = async (idMascota: string): Promise<FormState> => {
    const mascota = await buscarMascota(idMascota);
    return {
        nombresPropietario: {value: mascota?.nombresPropietario || '', wasTouched: false, isValid: undefined},
        nombre: {value: mascota?.nombre || '', wasTouched: false, isValid: undefined},
        foto: {value: undefined, wasTouched: false, isValid: undefined},
        certificadoVacuna: {value: undefined, wasTouched: false, isValid: undefined},
        fechaIngreso: {value: mascota?.fechaIngreso || '', wasTouched: false, isValid: undefined},
        raza: {value: mascota?.raza.id || '', wasTouched: false, isValid: undefined},
        sexo: {value: mascota?.sexo.toString() || '', wasTouched: false, isValid: undefined},
        fechaNacimiento: {value: mascota?.fechaNacimiento || '', wasTouched: false, isValid: undefined},
        comentarios: {value: mascota?.comentarios || '', wasTouched: false, isValid: undefined},
        estaEsterilizada: {value: mascota?.estaEsterilizada || false, wasTouched: false, isValid: undefined},
        tieneCondicionMedica: {value: mascota?.tieneCondicionMedica || false, wasTouched: false, isValid: undefined},
        observacionesMedicas: {value: mascota?.observacionesMedicas || '', wasTouched: false, isValid: undefined},
        nombreVeterinario: {value: mascota?.nombreVeterinario || '', wasTouched: false, isValid: undefined},
        temperamento: {value: mascota?.temperamento.toString() || '', wasTouched: false, isValid: undefined},
        observacionesTemperamento: {
            value: mascota?.observacionesTemperamento || '',
            wasTouched: false,
            isValid: undefined
        },
        observacionesAlimenticias: {
            value: mascota?.observacionesAlimenticias || '',
            wasTouched: false,
            isValid: undefined
        },
        fechaGarrapaticida: {value: mascota?.fechaGarrapaticida || '', wasTouched: false, isValid: undefined},
        mesesPeriodicidadGarrapaticida: {
            value: mascota?.mesesPeriodicidadGarrapaticida || '',
            wasTouched: false,
            isValid: undefined
        },
        fechaVacuna: {value: mascota?.fechaVacuna || '', wasTouched: false, isValid: undefined},
        eliminarFoto: {value: false, wasTouched: false, isValid: undefined},
        eliminarCertificadoVacuna: {value: false, wasTouched: false, isValid: undefined},
    }
}